<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';

defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['confirm']);

const { t } = useI18n();

const PRICING_DOCS_URL =
  'https://developers.facebook.com/documentation/business-messaging/whatsapp/calling/pricing';

const dialogRef = ref(null);

const open = () => dialogRef.value?.open();
const close = () => dialogRef.value?.close();

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    :title="t('CONVERSATION.HEADER.WHATSAPP_CALL_PAID_NOTICE.TITLE')"
    :cancel-button-label="
      t('CONVERSATION.HEADER.WHATSAPP_CALL_PAID_NOTICE.CANCEL')
    "
    :confirm-button-label="
      t('CONVERSATION.HEADER.WHATSAPP_CALL_PAID_NOTICE.CONFIRM')
    "
    confirm-button-color="green"
    :is-loading="isLoading"
    width="sm"
    @confirm="emit('confirm')"
  >
    <template #description>
      <p class="mb-0 text-sm text-n-slate-11">
        {{ t('CONVERSATION.HEADER.WHATSAPP_CALL_PAID_NOTICE.DESCRIPTION') }}
        <a
          :href="PRICING_DOCS_URL"
          target="_blank"
          rel="noopener noreferrer"
          class="text-n-brand underline"
        >
          {{ t('CONVERSATION.HEADER.WHATSAPP_CALL_PAID_NOTICE.LEARN_MORE') }}
        </a>
      </p>
    </template>
  </Dialog>
</template>
